<template lang="pug">

    div

        printing-prices.prices(
            v-for='printing in variantModel.printings'
            v-bind:key='printing'
            v-bind:additional-cost-models='additionalCostModels'
            v-bind:job-models='jobModels'
            v-bind:offer-models='offerModels'
            v-bind:price-models='findAllPriceModelsByPrinting(printing)'
            v-bind:product-model='productModel'
            v-bind:printing='printing'
            v-bind:supplier-models='supplierModels'
        )

        update-form-modal(
            ref='modal'
            v-bind:additional-cost-models='additionalCostModels'
            v-bind:job-models='jobModels'
            v-bind:offer-models='offerModels'
            v-bind:price-models='priceModels'
            v-bind:printings='variantModel.printings'
            v-bind:supplier-models='supplierModels'
        )

        .ui.clearing.right.aligned.basic.vertical.segment

            //- Info-Mail an Kunden
            button.ui.right.labeled.primary.icon.button(
                v-show="productModel.status === 'OFFERS_AVAILABLE'"
                type="button"
                v-on:click='sendMail()'
            )
                i.paper.plane.icon
                | Info-Mail an Kunden senden

            //- Preise bearbeiten
            button.ui.right.labeled.primary.icon.button(
                v-show="isEditable"
                type="button"
                v-on:click.prevent='showModal()'
            )
                i.pencil.icon
                | Preise bearbeiten

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import PrintingPrices from '@/components/products/prices/PrintingPrices'
    import UpdateFormModal from '@/components/products/prices/UpdateFormModal'

    //noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols
    export default {

        async beforeRouteEnter(to, from, next) {
            const productId = Number(to.params.id)
            const variantId = Number(to.params.variantId)

            const [ jobModels ] = await Promise.all([

                // Jobs laden
                store.dispatch('jobs/loadAllByProductId', { productId }),

                // Produkt laden
                store.dispatch('products/loadOne', { id: productId }),

                // Variante laden
                store.dispatch('variants/loadOne', { id: variantId })

            ])

            const [ offerModels ] = await Promise.all([

                // Angebote laden
                store.dispatch('offers/loadAllByJobModels', { jobModels }),

                // Supplier/Unternehmen laden
                store.dispatch('companies/loadAllByJobModels', { jobModels }),


            ])

            // Preise laden
            const priceModels = await store.dispatch('prices/loadAllByOfferModels', { offerModels })

            // Zusatzkosten laden
            await R.compose(

                // Promises zusammenfassen
                // > [ Promise, Promise, Promise ]
                // < Promise
                promises => Promise.all(promises),

                // Zusatzkosten lande
                // > [ 1, 2, 3 ]
                // < [ Promise, Promise, Promise ]
                R.map(id => store.dispatch('additionalCosts/loadOne', { id })),

                // ID von Zusatzkosten lesen
                // > [ { additionalCosts: [ 1, 2], ... }, { additionalCosts: [ 3 ], ... }  ]
                // < [ 1, 2, 3 ]
                R.chain(R.prop('additionalCosts'))

            )(priceModels)

            next()
        },

        components: { PrintingPrices, UpdateFormModal },

        computed: {

            additionalCostModels() {
                return store.getters['additionalCosts/all']
            },

            isEditable() {
                const status = this.productModel.status
                return status === 'IN_PROCESS' || status === 'OFFERS_AVAILABLE'
            },

            jobModels() {
                return store.getters['jobs/allByProductId'](this.productId)
            },

            offerModels() {
                return R.compose(

                    // Nach Variante filtern
                    // > [ { id: 5, variant: 1, ... }, { id: 6, variant: 1, ... }, { id: 8, variant: 2, ... } ]
                    // < [ { id: 5, variant: 1, ... }, { id: 6, variant: 1, ... } ]
                    R.filter(R.propEq('variant', this.variantId)),

                    // Angebote des Jobs holen
                    // > [ 1, 2  ]
                    // < [ { id: 5, variant: 1, ... }, { id: 6, variant: 1, ... }, { id: 8, variant: 2, ... } ]
                    R.chain(store.getters['offers/allByJobId']),

                    // ID aus Jobs lesen
                    // > [ { id: 1, ... }, { id: 2, ... } ]
                    // < [ 1, 2 ]
                    R.map(R.prop('id')),

                )(this.jobModels)
            },

            priceModels() {
                return R.compose(

                    // Preise der Angebote holen
                    // > [ 1, 2 ]
                    // < [ { id: 4, ... }, { id: 5, ... }, { id: 6, ... } ]
                    R.chain(store.getters['prices/allByOfferId']),

                    // Angebote durchlaufen und ID holen
                    // > [ { id: 1, ... }, { id: 2, ... } ]
                    // < [ 1, 2 ]
                    R.map(R.prop('id'))

                )(this.offerModels)
            },

            productId() {
                return R.pipe(R.prop('id'), Number)(this.$route.params)
            },

            productModel() {
                return store.getters['products/byId'](this.productId)
            },

            supplierModels() {
                return R.compose(

                    // Lieferant/Unternehmen holen
                    // > [ 1, 2 ]
                    // < [ { id: 1, ... }, { id: 2, ... } ]
                    R.map(store.getters['companies/byId']),

                    // Lieferanten/Unternehmen-IDs der Jobs lesen
                    // > [ { supplier: 1, ... }, { supplier: 2 } ]
                    // < [ 1, 2 ]
                    R.map(R.prop('supplier'))

                )(this.jobModels)
            },

            variantModel() {
                return store.getters['variants/byId'](this.variantId)
            },

            variantId() {
                return R.pipe(R.prop('variantId'), Number)(this.$route.params)
            }

        },

        methods: {

            findAllPriceModelsByPrinting(printing) {
                return R.filter(R.propEq('printing', printing), this.priceModels)
            },

            async sendMail() {
                try {
                    // Mail senden
                    await store.dispatch('mails/offerAvailableForVariantId', { variantId: this.variantModel.id })

                    // Erfolgsmeldung anzeigen
                    this.$growl.success('E-Mail wurde an Kunden versendet')

                } catch (e) {
                    // Fehlermeldung anzeigen
                    this.$growl.fatal('E-Mail konnte nicht an Kunden versendet werden', e)
                }
            },

            showModal() {
                this.$refs.modal.show()
            },

        },

    }

</script>

<!--suppress CssUnusedSymbol -->
<style scoped>

    .prices {
        margin-bottom: 2rem;
    }

</style>

